/* This file is autogenerated, see readme.md for instructions */
import RoadmapSvgIcon from '@bloomreach/banana-theme/icons/roadmap.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RoadmapIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RoadmapSvgIcon />
    </Icon>
  );
});

RoadmapIcon.displayName = 'RoadmapIcon';

export default RoadmapIcon;
